module.exports = __webpack_public_path__ + "static/media/left 1.57115adb.svg";